import React, { ReactNode } from 'react';
import { Button } from '@asigna/kit';
import { makeStyles, Theme } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import cx from 'classnames';
import closeIcon from 'images/close.svg';

const useStyles = makeStyles<Theme>((theme) => ({
  paper: {
    margin: '32px',
    [theme.breakpoints.down('sm')]: {
      margin: '0px',
      alignSelf: 'flex-start',
      paddingTop: '50px',
      minWidth: '90% !important',
      maxWidth: '96% !important',
    },
  },
  wrapper: {
    width: '540px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'center',
    padding: '32px',
    backgroundColor: '#202024',
    borderRadius: '12px',

    [theme.breakpoints.down('md')]: {
      padding: '24px',
      maxWidth: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
      width: '100%',
      maxWidth: '600px',
      minWidth: '100%',
      margin: '0 auto',
    },
  },
  fromBottom: {
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      position: 'fixed',
      left: '0',
      right: '0',
      bottom: '0',
      // background: '#292A2F',
      width: '98%',
      height: 'auto',
      flexDirection: 'column',
      borderRadius: '12px 12px 0 0',
      padding: '16px 16px 24px 16px',
      zIndex: 2,
      margin: '0 auto',
    },
  },
  dialogTitle: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  titleGroup: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  title: {
    fontWeight: 400,
    fontSize: '24px',
    lineHeight: '40px',
    color: '#fafafa',

    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
      lineHeight: '24px',
    },
  },
  subtitle: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#8a8a8a',
    marginTop: '4px',
  },
}));

interface TransactionCommonProps {
  open: boolean;
  children: ReactNode;
  button?: ReactNode;
  title: string;
  subtitle?: string;
  onClose: () => void;
  className?: string;
  isOverflowVisible?: boolean;
  fromBottom?: boolean;
}

// Unified Template for Transaction Properties Dialog
// Please pass in the comparison parameters before use
// TODO_R: move into @asigna/uikit
// TODO_R: [RCC]
export const TransactionCommonDialog = (props: TransactionCommonProps) => {
  const {
    open,
    title,
    subtitle,
    children,
    button,
    onClose,
    className,
    isOverflowVisible,
    fromBottom = false,
  } = props;
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      PaperProps={{
        className: cx(
          isOverflowVisible && 'dialog-content-visible',
          classes.paper,
          className || ''
        ),
      }}
      onClose={onClose}
    >
      <div
        className={cx(
          'bg-black-2 px-16 sm:px-24 py-16 sm:py-24 rounded-[12px] w-full sm:w-[540px] sm:mx-auto z-20 relative max-h-full border-[.5px] border-black-4',
          isOverflowVisible ? '' : 'overflow-y-auto',
          fromBottom && classes.fromBottom
        )}
      >
        <div className={classes.dialogTitle}>
          <div className={classes.titleGroup}>
            <div className={classes.title}>{title}</div>
            {subtitle && <div className={classes.subtitle}>{subtitle}</div>}
          </div>
          {/* TODO Icon Button */}
          <Button
            leftIcon={closeIcon}
            onClick={onClose}
            colorType="inherit"
            size="sm"
            className="w-40 h-40 border-[.5px] border-black-4 !px-0 hover:bg-white-3"
          />
        </div>
        {children}
        {button}
      </div>
    </Dialog>
  );
};
